const sGrade = window?.cfgs?.Sgrade
const sGradeA = sGrade == 0 // 文章等级为A
import Util from '../../utils/util'
import ArtFeed from '../../vue_components/art-feed.vue'; // 推荐阅读
import RecommendRead from '../../vue_components/recommend-read-main.vue'; // 推荐阅读-测试
import TopHeader from '../../vue_components/top-header-new.vue'
import NavMap from '../../vue_components/nav-map.vue' // 网站地图
import TransferArticle from '../../vue_components/transfer-article.vue';
import FooterMenu from '../../vue_components/footer-menu.vue'
import ShareSns from '../../vue_components/share-sns.vue';
import BackTop from '../../vue_components/back-top.vue';
import ArtRecommendSearch from '../../vue_components/art-recommend-search.vue';
import PlainDialog from '../../vue_components/plain-dialog.vue';
import ArticleOrigin from '../../vue_components/ArticleOrigin.vue'
import NewStatement from '../../vue_components/statement.vue';
import ArticleInsertLogic from '../article_insert_logic';
import FollowBtn from '../../vue_components/follow-btn/follow-btn.vue'
import TopHeaderTest from '../../vue_components/top-header-main-test.vue' // 实验导航
import BannedNotice from '../../vue_components/article-main/banned-notice.vue'
import Interaction from '@/vue_components/interaction/index.vue'
import BrowseHistoryRemind from '@/vue_components/browseHistoryRemind.vue';
const loginUtil = window.MptcfeLoginUtil
const loginUtilIns = new loginUtil()

// 底部评论
const renderCommentFooter = function() {
    if(!document.querySelector('#artCommentArea')) return
    import(/* webpackChunkName: "dynamic4footerComment" */'../../vue_components/article-main/footer-comment.vue')
    .then((res)=>{
        const CommentFooter = res.default
        new Vue({
            el: '#artCommentArea',
            components: {
                CommentFooter
            },
        });
    }).catch(()=>{
        MptcfeUtils.Utils.sendSpmAction(10674, `scene:wart;loadFooterComment:false;`) // 监控加载失败
    })
}

// 频道集合入口
const renderChannelEntry = function() {
    if(!document.querySelector('#channelEntry')) return
    if(!Util.isFromSearch()) return // 是否是搜多来源
    const Sgrade = window.cfgs?.Sgrade
    const category = window.cfgs?.category
    if(Sgrade != 0) return // 只有A等级文章才需要此区块
    if(!category) return
    import(/* webpackChunkName: "dynamic4channelEntry" */'../../vue_components/article-main/channel-entry.vue')
    .then((res)=>{
        const ChannelEntry = res.default
        new Vue({
            el: '#channelEntry',
            components: {
                ChannelEntry: ChannelEntry
            },
        });
    }).catch(()=>{})
}

// 相关推荐
const renderRecommend = () => {
    if(!document.querySelector('#artRecNews')) return
    const Sgrade = window.cfgs?.Sgrade
    if(Sgrade > 1) return  // s s+ 不展示
    // 百度文章使用ArtFeed
    // 命中实验使用RecommendRead
    const isTest = window.AB_TEST?.recommendtab
    const isNotBaidu = !(window?.sohuSpm?.getCodes()?.b === 'content-bd')
    let comp = (isTest && isNotBaidu) ? RecommendRead : ArtFeed
    new Vue({
        el: '#artRecNews',
        components: {
            RecommendRead: comp
        },
        data() {
            return {
                config: {
                    canFeedback: true, // 支持反馈弹框
                    maxShowNumber: 40,//推荐阅读最大展示条数
                    articleScene: 'normal' //普通文章页
                },
            }
        },
        computed: {
            //推荐阅读请求内容的条数
            size() {
                return 40
            },
        },
    });
}

// 顶部导航栏组件
const rendertopHeader = () => {
    if(!document.querySelector('#topHeader')) return
    const isTest = window?.AB_TEST?.callSohunews == 1 // 命中实验
    new Vue({
        el: '#topHeader',
        template: '<topHeader/>',
        components: {
            TopHeader: isTest ? TopHeaderTest : TopHeader
        },
    })
}

// 底部网站地图 s+与s级别不展示
const renderNavMap = () => {
    if(!document.querySelector('#navMap')) return
    const Sgrade = window.cfgs?.Sgrade
    if(Sgrade > 1) return  // s s+ 不展示
    new Vue({
        el: '#navMap',
        components: {
            NavMap
        },
    })
}

// 转载文章声明
const renderTransferArticle = () => {
    if(!document.querySelector('#transferArticle')) return
    new Vue({
        el: '#transferArticle',
        components: {
            TransferArticle
        },
        mounted() {
        }
    });
}

// 底部版权申明
const renderFooterMenu = () => {
    if(!document.querySelector('#footerMenu')) return
    new Vue({
        el: '#footerMenu',
        components: {
            FooterMenu
        },
    })
}

// 分享
const renderShare = () => {
    if(!document.querySelector('#shareArea')) return
    new Vue({
        el: '#shareArea',
        components: {
            ShareSns
        },
        methods: {
        }
    });
}

// 回到顶部
const renderBackTop = () => {
    if(!document.querySelector('#backTop')) return
    new Vue({
        el: '#backTop',
        data() {
            return {
                loading: true,
                stat: {},

            }
        },
        components: {
            BackTop
        }
    });
}

// 推荐搜索
const renderRecommendSearch = () => {
    if(!document.querySelector('#recommendSearch')) return
    const Sgrade = window.cfgs?.Sgrade
    if(Sgrade > 1) return  // s s+ 不展示
    new Vue({
        el: '#recommendSearch',
        components: {
            ArtRecommendSearch
        }
    });
}

// 推荐搜索
const renderToastDialog = () => {
    if(!document.querySelector('#toastDialog')) return
    new Vue({
        el: '#toastDialog',
        components: {
            PlainDialog
        }
    })
}

// 文章来源标识
const renderArticleOrigin = () => {
    if(!document.querySelector('#articleOrigin')) return
    new Vue({
        el: '#articleOrigin',
        components: {
            ArticleOrigin
        }
    })
}

//底部标签 && 声明
const renderNewStatement = () => {
    if(!document.querySelector('#newStatement')) return
    new Vue({
        el: '#newStatement',
        components: {
            NewStatement
        }
    })
}

// 文章页插入内容相关逻辑(当有功能卡时才进行进一步操作)
const renderArticleInsertLogic = () => {
    if (document.querySelectorAll('.article-main mp-plugin').length) {
        ArticleInsertLogic.articleInsert()
    }
}

const renderFollowAuthor = () => {
    if(!document.querySelector('#followAuthor')) return
    new Vue({
        el: '#followAuthor',
        data() {
            return {
                userInfo: null,
            }
        },
        components: {
            FollowBtn
        },
        created() {
            loginUtilIns.checkLogin({
                env: window.env,
                successFun: (res) => {
                    this.userInfo = res.data
                    this.$nextTick(() => {
                        this.$refs.refFollowBtn.initTipPage()
                    })
                }
            })
        },
        methods: {
            showFollowEntry() {
                $('.subscribe-container').show();
                    window.sohuSpm?.domDidChange({
                        target: 'followmore'
                    })
                },
            // 获取关注状态 false:未关注  true：已关注
            updateFollowStatus(status) {
                window.EVENT_BUS.$emit('updateFollowStatus', status)
            }
        },
        mounted() { },
    });
}

// 禁言封禁通知
const showBannedNotice = ()=>{
        if(!document.querySelector('#bannedNotice')) return
        new Vue({
            el: '#bannedNotice',
            components: {
                BannedNotice: BannedNotice
            }
        });
}
// 互动(评论+视野+讨论)
const renderInteration = () => {
    if(!document.querySelector('#interaction')) return
    new Vue({
        el: '#interaction',
        components: {
            Interaction
        }
    });
}

export default {
    renderCommentFooter,
    renderChannelEntry,
    renderRecommend,
    rendertopHeader,
    renderNavMap,
    renderTransferArticle,
    renderFooterMenu,
    renderShare,
    renderBackTop,
    renderRecommendSearch,
    renderToastDialog,
    renderArticleOrigin,
    renderNewStatement,
    renderArticleInsertLogic,
    renderFollowAuthor,
    showBannedNotice,
    renderInteration,
}